<template>
    <div>
        <div class="container text-center mt-5">
            <div class="card">
                <div class="d-flex justify-content-between align-items-center  pt-3 mb-3">
                    <!-- <div class="d-flex"> -->
                    <div class="d-flex">
                        <span style=" padding: 6px 7px 10px 25px;">Filtrar: </span>
                        <div class="d-grid mr-3">
                            <input class="form-control mr-2 w-100" v-model="form.palavra_filtro" type="text">
                            <input type="checkbox" id="meuCheckbox" v-model="form.palavra_exata">
                            <label for="meuCheckbox" style="font-weight: 400;"> Pesquisar por palavra EXATA</label>
                        </div>

                        <button class="btn btn-info mr-1" @click="setFilter()" style="height: 45px; justify-content: center; display: flex; align-items: center;">
                            <i class="fas fa-search mr-1"></i>
                        </button>
                        <button v-if="showLimparFiltro" class="btn btn-light" @click="limparFiltro()">
                            <i class="fas fa-times mr-1"></i>
                        </button>
                    </div>
                    <div>
                        <button class="btn btn-success mr-3"
                            @click="exibirModalDicionario = true, dicionarioGlobal = ''"><i
                                class="fas fa-plus mr-1"></i>
                            Adicionar</button>
                    </div>
                </div>

                <table class="table table-striped ">
                    <thead>
                        <tr>
                            <th scope="col">Elemento</th>
                            <th scope="col">Português</th>
                            <th scope="col">Espanhol</th>
                            <th scope="col">Inglês</th>
                            <th scope="col">Francês</th>
                            <th scope="col">Holandes</th>
                            <th scope="col">Alemao</th>
                            <th scope="col">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(palavra, index) in getPalavras" :key="index">
                            <td>{{ palavra.name }}</td>
                            <!-- <td v-for="(lang_system, indice) in palavra.lang_system" :key="indice"> -->
                            <td v-for="lang in idiomas" :key="lang">
                                {{ getTranslate(palavra, lang) }}
                            </td>
                            <th scope="row"><button class="btn btn-warning mr-2" @click="exibirModalEditar(palavra)"><i
                                        class="fa fa-pen"></i></button>
                                <button class="btn btn-danger  mr-2" @click="excluirPalavra(palavra)"><i
                                        class="fa fa-trash"></i></button>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <pagination-dicionario></pagination-dicionario>
            </div>
        </div>
        <modal-dicionario v-if="exibirModalDicionario" @closeModal="exibirModalDicionario = false"
            :palavra="dicionarioGlobal"></modal-dicionario>
    </div>
</template>
<script>
import ModalDicionario from './ModalDicionario.vue'
import PaginationDicionario from './PaginationDicionario.vue'

export default {
    data() {
        return {
            exibirModalDicionario: false,
            textPesquisa: '',
            form: {
                palavra_exata: false
            },
            showLimparFiltro: false,
            idiomas: ['pt', 'es', 'en', 'fr', 'ho', 'ge']
        }
    },

    components: {
        ModalDicionario,
        PaginationDicionario
    },
    computed: {
        getPalavras() {
            const palavras = this.$store.getters['painel/getPalavras']

            if (!palavras) {
                this.$store.dispatch('painel/getPalavras')

                return []
            }


            return palavras
        }
    },
    created() {
        this.$store.dispatch('painel/getPalavras')
    },

    methods: {
        getTranslate(palavra, lang){
            const item = palavra.lang_system.find(
                l => l.language_code === lang
            )

            return item ? item.translate: '-'
        },
        limparFiltro() {
            this.showLimparFiltro = false
            this.form = {}
            this.$store.commit('painel/setFilters', { filters: {} })
            this.$store.dispatch('painel/getPalavras')

        },

        setFilter() {
            const data = {
                ...this.form,
                palavra_filtro: this.form.palavra_filtro.toUpperCase(),
                palavra_exata: this.form.palavra_exata
            }

            this.$store.commit('painel/setFilters', { filters: data })
            this.$store.dispatch('painel/getPalavras')
            this.showLimparFiltro = true
        }, 

        exibirModalEditar(palavra) {
            console.log(palavra)

            this.dicionarioGlobal = palavra
            this.exibirModalDicionario = true
        },

        excluirPalavra(palavra) {
            console.log(palavra)

            this.$swal.fire({
                title: 'Excluir a palavra e tradução?',
                text: `Deseja excluir a palavra e tradução?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirmar'
            }).then(result => {
                if (result.dismiss !== 'cancel' && result.dismiss !== 'backdrop') {
                    this.$store.dispatch('painel/deletePalavra', { data: palavra }).then((response) => {

                        this.$store.dispatch('painel/getPalavras')

                        this.$swal.fire({
                            title: 'Excluído com sucesso!',
                            text: 'O agendamento foi excluído com sucesso',
                            icon: 'success',
                            timer: 1000
                        })
                    }).catch((error) => {
                        console.log(error)
                        this.$swal.fire({
                            title: 'Ooops!',
                            text: 'Ocorreu um erro, tente novamente!',
                            icon: 'warning'
                        })
                    })
                }
            })
        },

    }
}
</script>